import React from 'react';
import { shownState } from '../domain/listingLifecycle';
import type { Listing } from '../domain/listings';
import { Badge } from '@/components/ui/badge';

function scheduledTime(iso: string): string {
  return new Date(iso).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

/**
 * Sold, for everyone; Draft, Scheduled · time and Withdrawn, for the author
 * (the only one who can see those listings at all).
 */
export default function ListingStateBadge({
  listing,
  className = '',
}: {
  listing: Listing;
  className?: string;
}) {
  const state = shownState(listing);
  if (!state) return null;
  const label =
    state.kind === 'sold'
      ? 'Sold'
      : state.kind === 'draft'
        ? 'Draft'
        : state.kind === 'withdrawn'
          ? 'Withdrawn'
          : `Scheduled · ${scheduledTime(state.at)}`;
  const tone =
    state.kind === 'sold' ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground';
  return (
    <Badge
      className={`rounded-full border-transparent px-3 py-1 text-xs font-bold ${tone} ${className}`}
    >
      {label}
    </Badge>
  );
}
